import React, { useState } from "react";
import "./Header.css";
import Logo from "../../assets/Logo.png";
import Bars from "../../assets/bars.png";
import { Link } from "react-scroll";
const Header = () => {
    const mobile = window.innerWidth<= 768? true: false;
    const [menuOpened, setMenuOpened] = useState(false);
    return (
        <div className="header" id="">
            <img src={Logo} alt="Logo-Marca" className="logo" />
            {(menuOpened === false && mobile === true)? (
                <div style={{backgroundColor: '#3c3f45', padding: '0.5rem', borderRadius: "5px"}}
                onClick={() => setMenuOpened(true)}>
                    <img src={Bars} alt="" style={{width: '1.5rem', height: '1.5rem'}}/>
                </div>
            ):
            <ul className="header-menu">
                <li>
                    <Link
                    onClick={() => setMenuOpened(false)}
                    activeClass="active"
                    to="home"
                    span={true}
                    smooth={true}
                    >Home</Link>
                </li>

                <li>
                    <Link
                    onClick={() => setMenuOpened(false)}
                    to="programas"
                    span={true}
                    smooth={true}
                    >Programas</Link>
                </li>
                
                <li>
                    <Link
                    onClick={() => setMenuOpened(false)}
                    to="por-que-nos"
                    span={true}
                    smooth={true}
                    >Por que nós</Link>
                </li>
                <li>
                    <Link
                    onClick={() => setMenuOpened(false)}
                    to="planos"
                    span={true}
                    smooth={true}
                    >Planos</Link>
                </li>

                <li><Link
                    onClick={() => setMenuOpened(false)}
                    to="testimonials"
                    span={true}
                    smooth={true}>Depoimentos</Link></li>
            </ul>
            }                
        </div>
    )
}
export default Header;